import React from 'react';
import styled from 'styled-components';
import { Color } from '../app/StyleGuide';
import WhiteLabel from '../filters/WhiteLabel';
import LoadingIndicator from './LoadingIndicator';

// This styling is a legacy holdover.
// We likely will want to remove/replace it at some point.
const Styles = styled.div`
  margin: 80px 20px;
`;

type LoadingStateProps = {
  hideText?: boolean;
  children?: React.ReactNode;
};

const LoadingState = (props: LoadingStateProps) => (
  <Styles>
    <LoadingIndicator {...props} color={WhiteLabel.isGrid() ? Color.Blue._50 : Color.Gray._50}>
      {!props.hideText && (props.children || <span>Loading</span>)}
    </LoadingIndicator>
  </Styles>
);

export default LoadingState;
